import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * A password box you can read back.
 *
 * Typing a password you cannot see, twice, on a phone keyboard, is how people
 * end up locked out of an account they just created. Each field keeps its own
 * toggle rather than sharing one, so revealing the confirm box does not also
 * reveal the one above it.
 *
 * The eye is tabIndex={-1} on purpose: tab should go from password straight to
 * confirm, not via a button nobody wants to land on.
 */
export default function PasswordInput({ className = "", ...props }) {
  const [show, setShow] = useState(false);
  const label = show ? "Hide password" : "Show password";
  return (
    <div className="relative">
      <Input {...props}
             type={show ? "text" : "password"}
             className={`pr-9 ${className}`} />
      <button type="button"
              tabIndex={-1}
              onClick={() => setShow((s) => !s)}
              aria-label={label}
              title={label}
              data-testid="pw-toggle"
              className="absolute inset-y-0 right-0 px-2.5 flex items-center text-zinc-400 hover:text-zinc-700">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
